import { render } from "./pageRedirect.vue?vue&type=template&id=7196050b&scoped=true"
import script from "./pageRedirect.vue?vue&type=script&lang=js"
export * from "./pageRedirect.vue?vue&type=script&lang=js"

import "./pageRedirect.vue?vue&type=style&index=0&id=7196050b&scoped=true&lang=scss"

import exportComponent from "/pxplus_redirect/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7196050b"]])

export default __exports__